export default function Problem() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
          Local customers don't wait for replies
        </h2>
        
        <p className="text-xl text-gray-700 mb-6 leading-relaxed">
          Long Island customers request multiple quotes.<br />
          The business that responds first usually wins.
        </p>

        <p className="text-lg text-gray-600 leading-relaxed">
          Automigo responds instantly so opportunities don't disappear.
        </p>
      </div>
    </section>
  );
}
